<ng-container [formGroup]="jobForm">
    <ion-row class="dp-form-base-data-wrap">
        <ion-col size="6" size-xl="3">
            <ion-item class="job-info-field job-name bg-light" lines="none">
                <ion-input
                    type="text"
                    formControlName="name"
                    [label]="'projects.jobs.details.name-label' | translate"
                    labelPlacement="floating"
                    [readonly]="!changesAllowed"
                ></ion-input>
            </ion-item>
        </ion-col>
        <ion-col size="6" [attr.size-xl]="hideCodeField == true ? '3' : '2'">
            <ion-item class="job-info-field job-number bg-light" lines="none">
                <ion-input
                    type="text"
                    formControlName="jobNumber"
                    [label]="'projects.jobs.details.number-label' | translate"
                    labelPlacement="floating"
                    [readonly]="!changesAllowed"
                ></ion-input>
            </ion-item>
        </ion-col>
        <ion-col size="12" size-lg="4" size-xl="2" *ngIf="!utils.isPhone && !hideCodeField">
            <ion-item class="job-info-field job-code bg-light" lines="none">
                <ion-input
                    type="text"
                    formControlName="code"
                    [label]="'projects.jobs.details.code-label' | translate"
                    labelPlacement="floating"
                    [placeholder]="'projects.jobs.details.article.fill-code-placeholder' | translate"
                    [readonly]="!changesAllowed"
                ></ion-input>
                <ion-button
                    *ngIf="changesAllowed"
                    slot="end"
                    fill="clear"
                    class="round code-scan-btn"
                    dpTooltip
                    [tooltipContent]="'projects.jobs.details.article.scan-code-placeholder' | translate"
                    tabindex="1"
                    (click)="toggleScan($event)"
                >
                    <fa-icon icon="qrcode" slot="icon-only"></fa-icon>
                </ion-button>

                <ion-modal [isOpen]="scanModalVisible" (ionModalDidDismiss)="scanModalVisible = false" class="scanner-modal">
                    <ng-template>
                        <ion-header>
                            <ion-header>
                                <ion-toolbar color="none">
                                    <ion-title>{{ 'projects.jobs.details.article.scan-code-placeholder' | translate }}</ion-title>
                                    <ion-buttons slot="end">
                                        <ion-button fill="clear" shape="round" color="primary" (click)="scanModalVisible = false">
                                            <fa-icon slot="icon-only" icon="times"></fa-icon>
                                        </ion-button>
                                    </ion-buttons>
                                </ion-toolbar>
                            </ion-header>
                        </ion-header>
                        <ion-content class="ion-no-padding">
                            <app-code-scanner
                                class="dialog-scanner"
                                [(isEnabled)]="scanModalVisible"
                                containerType="modal"
                                [searchIcon]="'check'"
                                (onScanCancel)="scanModalVisible = false"
                                (onScanResult)="onScanFieldCodeResult($event)"
                            ></app-code-scanner>
                        </ion-content>
                    </ng-template>
                </ion-modal>
            </ion-item>
        </ion-col>
        <ion-col size="6" [attr.size-lg]="hideCodeField == true ? '6' : '4'" [attr.size-xl]="hideCodeField == true ? '3' : '2'">
            <app-date-time-picker
                [timestamp]="jobForm.get('date').value"
                [changesAllowed]="changesAllowed"
                (dateChanged)="onJobDateChanged($event)"
            ></app-date-time-picker>
        </ion-col>
        <ion-col size="6" [attr.size-lg]="hideCodeField == true ? '6' : '4'" size-xl="3">
            <ion-item class="job-info-field job-worker bg-light" (click)="maybeToggleWorkerDrawer()" lines="none">
                <ion-input
                    labelPlacement="floating"
                    [label]="'projects.jobs.details.creator-label' | translate"
                    type="text"
                    class="mobile-worker-input"
                    [value]="workerDrawerValue.name"
                    readonly="true"
                >
                </ion-input>
                <app-select-drawer
                    *ngIf="changesAllowed"
                    appendTo="ion-app"
                    [value]="workerDrawerValue"
                    [items]="workerItems"
                    [stackModal]="asDialog"
                    allowEmpty="true"
                    (onChange)="onMobileSelectItemChanged($event)"
                    #selectWorkerDrawer
                ></app-select-drawer>
            </ion-item>
        </ion-col>
        <!-- <ion-col size="12">
			<hr style="border-bottom: 1px solid" />
		</ion-col> -->
    </ion-row>
</ng-container>
